module.exports = __webpack_public_path__ + "static/media/icone-meditabem.165b8472.png";